import { apiClient } from '@/config/api';
import { User } from '@/types';

export interface LoginCredentials {
  email: string;
  password: string;
  remember?: boolean;
}

export interface LoginResponse {
  token: string;
  refresh_token?: string;
  user?: User;
}

export const authService = {
  async login(credentials: LoginCredentials): Promise<LoginResponse> {
    const response = await apiClient.post<LoginResponse>('/login', credentials);
    return response.data;
  },

  async logout(): Promise<void> {
    // Clear tokens on client side securely
    try {
      localStorage.removeItem('auth_token');
      localStorage.removeItem('refresh_token');
    } catch (error) {
      console.error('Error clearing tokens:', error);
    }
  },

  async refreshToken(refreshToken: string): Promise<{ token: string; refresh_token?: string }> {
    const response = await apiClient.post<{ token: string; refresh_token?: string }>('/token/refresh', {
      refresh_token: refreshToken,
    });
    return response.data;
  },
};
